module.exports = __webpack_public_path__ + "media/images/noticia03-37e881d2acd6f8342ad42fc50ae4c9a0.jpg";